import type { DateLike } from "@vueuse/core";
import moment from "moment";

moment.localeData("es-mx");

const useDateFormat = (date: DateLike) => {
  const localDate = new Date(date || "");
  const normalizedDate = new Date(
    localDate.getTime() + localDate.getTimezoneOffset() * 60000,
  );

  const momentDate = moment(normalizedDate);

  const dateFormat = momentDate.format("dddd, DD MMMM YYYY");
  const dateFormatNoDay = momentDate.format("DD MMMM YYYY");
  const dateTimeFormat = momentDate.format("MMMM Do YYYY, h:mm:ss a");

  return {
    date: dateFormat,
    dateTime: dateTimeFormat,
    dateNoDay: dateFormatNoDay,
  };
};

export default useDateFormat;
